class PredictiveSearch extends HTMLElement {
constructor() {
  super();

  this.input = this.querySelector('input[type="search"]');
  this.predictiveSearchResults = this.querySelector('#predictive-search-inline') 
    || this.querySelector('#predictive-search');

  if (!this.input || !this.predictiveSearchResults) return;

  this.input.addEventListener('input', this.debounce((event) => {
    this.onChange(event);
  }, 300).bind(this));
}

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

getSearchResults(searchTerm) {
  const params = new URLSearchParams({
    q: searchTerm,
    section_id: 'predictive-search',
    'resources[type]': 'product,collection',
    'resources[options][fields]': 'title',
    'resources[limit]': '10',

  });

  fetch(`${routes.predictive_search_url}?${params}`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
    })
    .catch((error) => {
      this.close();
      throw error;
    });
}

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);